export default __webpack_public_path__ + "static/media/nfo_checkout_cart_banner_service_fund.53229d0c.svg";